import {
  DataType,
  FormField,
} from '@labrav/react-components/lib/@types/types/forms'
import {
  currencyOptions,
  getCurrencyLabelForDisplay,
} from '../../../utils/getCurrencyLabelForDisplay'

export const multiSelectData: FormField = {
  title: 'Select currencies (Optional)',
  placeHolder: 'Select one or more currencies',
  humanReadableKey: 'currencies',
  id: 'currencies',
  isReadOnly: false,
  isRequired: false,
  defaultValue: undefined,
  dataType: 'multi_enum' as DataType,
  validationType: undefined,
  isCustom: false,
  options: Object.values(currencyOptions).map(option =>
    getCurrencyLabelForDisplay(option.key)
  ),
}

export const sellerTypeConfig = [
  {
    id: 'isSellerTypeISV',
    text: 'Independent Software Vendor (ISV)',
    description:
      'Your product(s) can be sold directly to customers or through third-party channels.',
    value: 'ISV',
  },
  {
    id: 'isSellerTypeCP',
    text: 'Channel Partner (CP)',
    description: 'You partner with ISVs and sell software on behalf of an ISV.',
    value: 'CP',
  },
]
